import { useAppStore } from './app.store'

useAppStore.subscribe(
  (state) => state.auth.user,
  (state, oldState) => {
    if (!state) {
      console.log(state, oldState)
    }
  },
)
